<!--
 * @Author: your name
 * @Date: 2020-08-25 08:25:41
 * @LastEditTime: 2020-10-14 09:48:34
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \jiachi\src\components\head.vue
-->
<template>
<div class="head" :style="{backgroundImage:'url('+backgroundImage+')'}">
    <p class="title">{{title}}</p>
    <p class="sub-title">{{subTitle}}</p>
    <div class="children" v-show="show">
        <router-link tag="div" :to="{path:item.path}" v-for="(item, index) in chilren" :key="index" :class="{active:path.indexOf(item.path)!== -1}">{{item.name}}</router-link>
    </div>
</div>
</template>

<script>
export default {
    props: ["backgroundImage", "title", "subTitle", 'show'],
    data() {
        return {
            chilren: [],
            active: false,
        };
    },
    computed: {
        path() {
            return this.$route.path;
        },
    },
    created() {
        let arr =
            this.$router.options.routes.filter((val) => {
                return val.meta.id == this.$route.meta.id;
            }) || [];
        this.chilren = arr[0] ? arr[0].children : [];
    },
};
</script>

<style lang="less" scoped>
.head {
    width: 100%;
    height: 580px;
    position: relative;
    background-size: cover;
    background-repeat: no-repeat;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;

    .children {
        position: absolute;
        bottom: 0;
        display: flex;
        justify-content: center;
        width: 100%;

        &>div {
            width: 200px;
            height: 60px;
            line-height: 60px;
            text-align: center;
            font-size: 16px;
            font-family: Source Han Sans CN;
            font-weight: 400;
            color: rgba(255, 255, 255, 0.78);
            border-top: 1px solid rgba(255, 255, 255, 0.5);
            margin-right: 10px;
            cursor: pointer;
        }

        &>div.active {
            background: #126fcc;
            border: none;
        }
    }
}

.title {
    font-size: 42px;
  font-family: Source Han Sans CN;
    font-weight: 500;
    color: rgba(255, 255, 255, 1);
}

.sub-title {
    font-size: 30px;
    font-family: Source Han Sans CN;
    font-weight: 500;
    color: rgba(255, 255, 255, 1);
}
</style>
